export const defaultColors = {
	brandGreen: 'hsl(134, 70%, 18%)',
	brandGreenAccent: 'hsl(134, 68.8%, 21.4%)',
	brandGreenLight: 'hsl(134, 35%, 38.6%)',
	brandGreenBlue: 'hsl(158, 24%, 25%)',
	brandGreenTranslucent: 'hsla(134, 34%, 73%, 0.5)',
	brandGreenOpaque: 'hsla(134, 34%, 73%, 0.2)',

	brandYellow: 'hsla(55, 93%, 73%, 1)',

	gradientBackgroundStart: 'hsl(134, 20.40%, 78.80%)',
	gradientBackgroundStop: 'hsl(133, 13.50%, 66.50%)',

	accentBlue: 'hsl(214, 68%, 56%)',
	accentRed: 'hsl(0, 70.10%, 60.60%)',
	accentRedLight: 'hsl(0, 80%, 80%)',
	accentRedFaded: 'hsl(0, 80%, 85%)',
	accentGreen: 'hsl(132, 38.80%, 54.50%)',
	accentGreenLight: 'hsl(132, 38.80%, 74.50%)',
	accentOrange: 'hsl(26, 91.10%, 48.60%)',
	accentYellow: 'hsl(44, 100.00%, 49.40%)',

	darkGreenGray: '#hsl(160, 11.10%, 5.30%)',
	darkestGray: 'hsl(156, 12.20%, 8.00%)',
	darkGray: 'hsl(227, 18.40%, 28.80%)',
	gray: 'hsl(192, 3.10%, 68.80%)',
	lightGray: 'hsl(0, 0.00%, 87.80%)',
	lighterGray: 'hsl(0, 0.00%, 93.70%)',
	lightestGray: 'hsl(0, 0.00%, 98.00%)',
	white: 'hsl(0, 0.00%, 100.00%)',
	black: 'hsl(0, 0.00%, 0.00%)',
}

export const defaultColorsDark = {
	brandGreen: 'hsl(155, 78%, 35%)',
	brandGreenAccent: 'hsl(155, 67.3%, 20%)',
	brandGreenLight: 'hsl(155, 78.4%, 60%)',
	brandGreenBlue: 'hsl(155, 24%, 25%)',
	brandGreenTranslucent: 'hsla(155, 78.4%, 40%, 0.2)',
	brandGreenOpaque: 'hsla(155, 55.7%, 27.5%, 0.1)',

	brandYellow: 'hsl(55, 93%, 73%)',
	brandYellowTranslucent: 'hsla(55, 93%, 73%, 0.2)',

	gradientBackgroundStart: 'hsl(134, 20.40%, 78.80%)',
	gradientBackgroundStop: 'hsl(133, 13.50%, 66.50%)',

	accentBlue: 'hsl(214, 68%, 56%)',
	accentRed: 'hsl(0, 70%, 60%)',
	accentRedLight: 'hsl(0, 80%, 80%)',
	accentRedFaded: 'hsl(0, 80%, 85%)',
	accentGreen: 'hsl(132, 39%, 55%)',
	accentGreenLight: 'hsl(132, 39%, 75%)',
	accentOrange: 'hsl(26, 91%, 49%)',
	accentYellow: 'hsl(44, 100%, 49%)',

	darkGreenGray: 'hsl(160, 11.1%, 5.3%)',
	darkestGray: 'hsl(185, 80%, 5.9%)',
	darkGray: 'hsl(187, 78.3%, 9%)',
	gray: 'hsl(187, 78.3%, 9%)',
	lightGray: 'hsl(0, 0%, 50.2%)',
	lighterGray: 'hsl(0, 0.00%, 75%)',
	lightestGray: 'hsl(0, 0%, 92.9%)',
	lightGreenGray: 'hsl(187, 35.4%, 18.8%)',
	white: 'hsl(0, 0%, 100%)',
	black: 'hsl(0, 0%, 0%)',
}
